import React from 'react'
import {ENGINE_URL,REPORT_URL,TERMINAL_URL} from './constants'
//require('es6-promise').polyfill();
//require('isomorphic-fetch');
//require('whatwg-fetch');

export const dataContext = React.createContext()

export function localestr(val,lang='ua'){
    return val
}

export function load(data={},func=()=>{}) {
  const controller = new AbortController()
  const id=setTimeout(() => controller.abort(), 6000)
    fetch(ENGINE_URL, { 
        signal: controller.signal,
        method: 'post',
        // mode: 'no-cors', //це удалити
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
        credentials: 'include', 
        body: data  
      })
      .then(  
        function(response) { 
          clearTimeout(id) 
          if (response.status !== 200) {
            const pos=data.indexOf('data=') 
            if (pos!==-1) {
              const newData=data.slice(pos+5)
              func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
            } else {
              func({status:'OffLine',key:data.slice(7)})  
            }
            return  
          }
          response.json().then(function(d) {
            func(d)
          });  
        }  
      )  
      .catch(function(err) { 
        clearTimeout(id)
        const pos=data.indexOf('data=') 
        if (pos!==-1) {
          const newData=data.slice(pos+5)
          func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
        } else {
          func({status:'OffLine',key:data.slice(7)})  
        }
      })
  }

export function report(data={},func=()=>{}) {
  const controller = new AbortController()
  const id=setTimeout(() => controller.abort(), 6000)
    fetch(REPORT_URL, { 
        signal: controller.signal,
        method: 'post',
        // mode: 'no-cors', //це удалити
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
        credentials: 'include', 
        body: data  
      })
      .then(  
        function(response) { 
          clearTimeout(id) 
          if (response.status !== 200) {
            const pos=data.indexOf('data=') 
            if (pos!==-1) {
              const newData=data.slice(pos+5)
              func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
            } else {
              func({status:'OffLine',key:data.slice(7)})  
            }
            return  
          }
          response.json().then(function(d) {
            func(d)
          });  
        }  
      )  
      .catch(function(err) { 
        clearTimeout(id)
        const pos=data.indexOf('data=') 
        if (pos!==-1) {
          const newData=data.slice(pos+5)
          func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
        } else {
          func({status:'OffLine',key:data.slice(7)})  
        }
      })
  }

  export async function loaddat(data,func=()=>{}){
    let response
    try {
      response = await fetch(ENGINE_URL, { // Your POST endpoint
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
        credentials: 'include', 
        body: data // This is your file object
      })
    } catch (error) {
      const pos1=data.indexOf('data=') 
      if (pos1!==-1) {
        const newData=data.slice(pos1+5)
        func({status:'OffLine',key:data.slice(7,pos1-1),data:JSON.parse(newData)})  
      } else {
        func({status:'OffLine',key:data.slice(7)})  
      }
      return
    }

    if (response.ok) { // если HTTP-статус в диапазоне 200-299
      let d = await response.json()
      func(d)
    } else {
      const pos=data.indexOf('data=') 
      if (pos!==-1) {
        const newData=data.slice(pos+5)
        func({status:'OffLine',key:data.slice(7,pos-1),data:JSON.parse(newData)})  
      } else {
        func({status:'OffLine',key:data.slice(7)})  
      }
    }
  }

  export async function loadpay(data,func=()=>{}){
    let response
    try {
      response = await fetch(TERMINAL_URL, { // Your POST endpoint
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'}, 
        credentials: 'include', 
        body: data // This is your file object
      })
    } catch (error) {
      func({status:'error',message:error.message})  
      return
    }

    if (response.ok) { // если HTTP-статус в диапазоне 200-299
      let d = await response.json()
      func(d)
    } else {
      func({status:'error',message:response.statusText})
    }
  }
  
export function uid(idx=0){
  //return '_' + Math.random().toString(36).substr(2, 9)
  return '_'+('' + (Date.now()+idx)).substring(7, 14)
}

export function isNumeric(value) {
  return !isNaN(value - parseFloat(value));
}

export function beginMn(d){
  let ret=new Date(d)
  ret.setDate(1)
  ret.setHours(0,0,0,0)
  return ret
}

export function endMn(d){
  let ret=new Date(d)
  ret.setMonth(ret.getMonth()+1)
  ret.setDate(1)
  ret.setHours(0,0,0,0)
  return(new Date(ret-1))
}

export function toText(val){
  if (val === null) return ''
  if (val === undefined) return ''
  if (typeof val === 'object') {
    if (toString.call(val)==='[object Date]') return val.toLocaleDateString()
    else if (val.name==='icon') return <img className='ico' src={val.src} alt={''} />
      else if (val.name==='color') return <div style={{width:'100%',height:'100%',backgroundColor:val.src}}/>
      else return val.name
  }
  else if (typeof val === 'string'){
    //if (val.substring(10, 11)==='T' && val.substring(13, 14)===':') return new Date(val).toLocaleDateString()
    if (val.substring(10, 11)==='T' && val.substring(13, 14)===':') return new Date(val).toLocaleString()
    if (val.substring(4, 5)==='-' && val.substring(7, 8)==='-') return new Date(val).toLocaleString()
    //else if(isNumeric(val)) return val*1
      else return val
  }
  else return val
}

export function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
  //.replace(/\-/g, '+')
  .replace(/-/g, '+')
  .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
      outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export function processFinishTo(finishTo) {
  if (!finishTo) return ''
  const match = /^([01]?\d|2[0-3])[:\\.](\d{2})$/.exec(finishTo);
  if (!match) {
      return finishTo;
  }
  const hours = parseInt(match[1], 10);
  const minutes = parseInt(match[2], 10);
  const now = new Date();
  const finishDate = new Date();
  finishDate.setHours(hours, minutes, 0, 0);
  let diffMs = finishDate - now;
  let isPast = diffMs < 0;
  if (isPast) diffMs = Math.abs(diffMs);
  const diffMinutes = Math.round(diffMs / 60000);
  const diffHours = Math.floor(diffMinutes / 60);
  let timeLeft = "";
  if (diffMinutes >= 120) timeLeft = `>${diffHours} год`;
  else timeLeft = `${diffMinutes} хв`;
  if (isPast) {
    if (diffMinutes >= 120) timeLeft = `-${diffHours} год ${diffMinutes - diffHours * 60} хв`;
    else timeLeft = `-${diffMinutes} хв`;
  }
  let bgColor = "green";
  if (isPast || diffMinutes <= 15) bgColor = "red";
  else if (diffMinutes <= 30) bgColor = "rgba(255, 51, 0, 1)";
  else if (diffMinutes <= 45) bgColor = "rgba(255, 123, 0, 1)";
  else if (diffMinutes < 60) bgColor = "rgba(255, 196, 0, 1)";
  return (
      <span style={{ backgroundColor: bgColor, color: "#fff", padding: "0px 6px 2px", borderRadius: "1rem", whiteSpace: "nowrap" }}>{timeLeft}</span>
  )
}
